import CreateStep1 from './../components/trials/CreateStep1'
import CreateStep2 from './../components/trials/CreateStep2'
import CreateStep3 from './../components/trials/CreateStep3'
import CreateStep4 from './../components/trials/CreateStep4'
import CreateStep5 from './../components/trials/CreateStep5'
import CreateStep6 from './../components/trials/CreateStep6'
import VueRouter from 'vue-router'

const routes = [
  { path: '/trials/create', component: CreateStep1, props: {stepType: 'trial'} },
  { path: '/trials/create/2', component: CreateStep2, props: {stepType: 'trial'} },
  { path: '/trials/create/3', component: CreateStep3, props: {stepType: 'trial'} },
  { path: '/trials/create/4', component: CreateStep4, props: {stepType: 'trial'} },
  { path: '/trials/create/5', component: CreateStep5, props: {stepType: 'trial'} },
  { path: '/trials/create/6', component: CreateStep6, props: {stepType: 'trial'} },
  { path: '/roll_outs/create', component: CreateStep1, props: {stepType: 'rollOut'} },
  { path: '/roll_outs/create/2', component: CreateStep2, props: {stepType: 'rollOut'} },
  { path: '/roll_outs/create/3', component: CreateStep3, props: {stepType: 'rollOut'} },
  { path: '/roll_outs/create/4', component: CreateStep4, props: {stepType: 'rollOut'} },
  { path: '/roll_outs/create/5', component: CreateStep5, props: {stepType: 'rollOut'} },
  { path: '/roll_outs/create/6', component: CreateStep6, props: {stepType: 'rollOut'} },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
})

export default router



// WEBPACK FOOTER //
// ./resources/js/router/index.js